import { Metric } from '../../../../dashboard-config/dashboard-config.model';
import {
  expandProductCatalog,
  ProductCatalogEntry,
} from '../../../_shared/dashboard-definition.model';
import { createDashboardIndexRankingDefinition } from './create-dashboard-index-ranking-definition';
import {
  IndexMetricProfile,
  indexCompaniesRevenueProfile,
  indexEconomicParticipantProfile,
  indexEmployedProfile,
  indexGrossValueAddedProfile,
} from './index-ranking-metric.profile';
import { DashboardIndexRankingShell } from './dashboard-index-ranking-shell.profile';
import { DashboardIndexRankingDefinition } from './dashboard-index-ranking.definition';

/**
 * Product catalog for national index map-ranking dashboards.
 * Identity is derived in {@link createDashboardIndexRankingDefinition}.
 */

// Pending dataset: CompaniesCount index.
type IndexRankingMetric = Exclude<
  Metric,
  Metric.Tourism | Metric.SelfEmployed | Metric.CompaniesCount
>;

export const INDEX_RANKING_PRODUCT_CATALOG: Record<
  IndexRankingMetric,
  ProductCatalogEntry<IndexMetricProfile, DashboardIndexRankingShell>
> = {
  [Metric.CompaniesRevenue]: {
    metric: indexCompaniesRevenueProfile,
    shells: ['wzClassStates', 'states', 'districts'],
  },
  // Pending dataset: districts.
  [Metric.GrossValueAdded]: {
    metric: indexGrossValueAddedProfile,
    shells: ['wzClassStates', 'states'],
  },
  // Pending dataset: districts.
  [Metric.EconomicParticipant]: {
    metric: indexEconomicParticipantProfile,
    shells: ['wzClassStates', 'states'],
  },
  [Metric.Employed]: {
    metric: indexEmployedProfile,
    shells: ['wzClassStates', 'states', 'districts'],
  },
};

/** All national index map-ranking product definitions. */
export const INDEX_RANKING_DEFINITIONS: DashboardIndexRankingDefinition[] =
  expandProductCatalog(
    Object.values(INDEX_RANKING_PRODUCT_CATALOG),
    createDashboardIndexRankingDefinition,
  );
